<script lang="ts" setup>
import { onMounted, ref } from "vue";
import TheSidebar from "@two-ui/components/TheSidebar.vue";
import { useRouter } from "vue-router";
import {
  getUserAndTheirOnboardingState,
  initializeStoreAndPluginsFromUser,
} from "@two-ui/user";
import { addHubspotScript } from "@two-ui/hubspot";
import { getUser, restoreAuthState } from "@two-ui/auth0";

// Load application fonts
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@wegift/company-brand-assets/dist/design-system/css/font-f37Lineca.css";

// App global styles
import "@two-ui/styles/global.sass";
import "@two-ui/styles/extensions.sass";
import "@two-ui/styles/type.sass";
import "@wegift/two-components/dist/style.css";
import { useGlobalStore } from "@workspace/packages/two-ui/src/global-store";

const router = useRouter();

const awaitingAuthChecks = ref(true);

onMounted(async () => {
  await initAndCheckAuthState();
  // Remove the loading state and allow the route to render
  awaitingAuthChecks.value = false;
});

// Fetch the state of the user and either redirect somewhere or initialise the store
const initAndCheckAuthState = async () => {
  const auth0User = await getUser();
  const auth0Token = await useGlobalStore().token();
  const isLoggedIn = await restoreAuthState();
  if (!(auth0User && isLoggedIn)) {
    router.push({ name: "auth-login" });
    return;
  }

  const { user } = await getUserAndTheirOnboardingState();
  addHubspotScript(); // Add script as user is logged in

  if (user) {
    initializeStoreAndPluginsFromUser(user, auth0User, auth0Token);
  }
};
</script>

<template>
  <FullPageLoader v-if="awaitingAuthChecks">Getting set up</FullPageLoader>
  <div
    v-else
    class="grid grid-cols-[230px_1fr] lg:grid-cols-[260px_1fr] xl:grid-cols-[270px_1fr]"
  >
    <TheSidebar />
    <router-view />
  </div>
</template>
